'use strict';

var $ = require('jquery');

/**
 * Effettuo il wrap della funzione extend di jQuery per lasciarci la possibilità di implementare una versione più performante
 */
module.exports = $.extend;
